<template>
  <!-- Tabla de Documentacion del proyecto: edicion por fila (lapiz Editar -> selects/inputs + Guardar/Eliminar),
       tipo de documento seleccionable y subida de PDF por fila. Replica el diseno S04. -->
  <div class="doc-table" :class="{ mark }">
    <table>
      <thead>
        <tr>
          <th>{{ $t('prm_summary_s04_col_doctype') }}</th>
          <th class="c">{{ $t('prm_summary_s04_col_contractual') }}</th>
          <th class="c">{{ $t('prm_summary_s04_col_delivered') }}</th>
          <th class="c">{{ $t('prm_summary_s04_col_approved') }}</th>
          <th>{{ $t('prm_summary_s04_col_comments') }}</th>
          <th class="c">{{ $t('prm_summary_s04_col_pdf') }}</th>
          <th class="c act"></th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(row, i) in localRows">
        <tr :key="row.id">
          <!-- Tipo de documento -->
          <td>
            <select v-if="row._editing" class="di-sel" :value="row.document" @change="onEdit(i, 'document', $event.target.value)">
              <option value=""></option>
              <option v-for="o in docTypeOptions" :key="o.value" :value="o.value">{{ o.label }}</option>
            </select>
            <span v-else class="di-val" :class="{ empty: !row.document }">{{ row.document ? docLabel(row.document) : $t('prm_summary_s04_col_doctype') }}</span>
          </td>
          <!-- Contractual / Entregado / Aprobado -->
          <td v-for="k in ynKeys" :key="k" class="c">
            <select v-if="row._editing" class="di-sel yn" :value="row[k]" @change="onEdit(i, k, $event.target.value)">
              <option value=""></option>
              <option v-for="o in ynOptions" :key="o.value" :value="o.value">{{ o.label }}</option>
            </select>
            <span v-else class="di-yn" :class="ynClass(row[k])">{{ ynLabel(row[k]) }}</span>
          </td>
          <!-- Comentarios -->
          <td>
            <input v-if="row._editing" class="di-in" type="text" :value="row.comments" :placeholder="$t('prm_summary_s04_col_comments')"
                   @change="onEdit(i, 'comments', $event.target.value)">
            <span v-else class="di-val" :class="{ empty: !row.comments }">{{ row.comments || '' }}</span>
          </td>
          <!-- Archivo PDF con historial de versiones (componente reutilizable). -->
          <td class="c">
            <prm-versioned-file :file="fileFor(row)" :editing="true" :project-id="projectId"
              :open="historyRow === row.id" :upload-url="uploadUrl(row)"
              @uploaded="onFileUploaded" @toggle-history="toggleHistory(row.id)"></prm-versioned-file>
          </td>
          <!-- Acciones: Editar (lapiz) en reposo; Guardar (check) + Eliminar (trash) en edicion -->
          <td class="c act">
            <div class="act-btns">
              <template v-if="row._editing">
                <button class="ib" v-tip="$t('prm_summary_s03_save')" @click="toggleEdit(i)"><b-icon pack="fas" icon="check" size="is-small"></b-icon></button>
                <button class="ib rm" v-tip="$t('prm_summary_remove_row')" @click="removeRow(i)"><b-icon pack="fas" icon="trash-can" size="is-small"></b-icon></button>
              </template>
              <button v-else class="ib" v-tip="$t('prm_summary_s04_edit_document')" @click="toggleEdit(i)"><b-icon pack="fas" icon="pen" size="is-small"></b-icon></button>
            </div>
          </td>
        </tr>
        <!-- Histórico documental: fila que se despliega bajo el registro. -->
        <tr v-if="historyRow === row.id && fileFor(row)" :key="row.id + '-h'" class="hist-tr">
          <td :colspan="7"><prm-file-history :file="fileFor(row)" :base-url="baseUrl" :project-id="projectId" @close="historyRow = null"></prm-file-history></td>
        </tr>
        </template>
        <tr v-if="!localRows.length"><td :colspan="7" class="empty">{{ $t('prm_summary_empty') }}</td></tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import PrmVersionedFile from './versioned-file.vue'
  import PrmFileHistory from './file-history.vue'
  import { tip } from '../shared/tip'

  let seq = 0
  function genId () { return 'r' + Date.now().toString(36) + (seq++).toString(36) + Math.random().toString(36).slice(2, 6) }

  export default {
    name: 'PrmDocumentsTable',

    components: { PrmVersionedFile, PrmFileHistory },

    directives: { tip },

    props: {
      rows: { type: Array, default: () => [] },
      docTypeOptions: { type: Array, default: () => [] },
      ynOptions: { type: Array, default: () => [] },
      projectId: { type: [Number, String], default: null },
      baseUrl: { type: String, default: '' },
      files: { type: Object, default: () => ({}) },
      mark: { type: Boolean, default: false },
      resetKey: { type: Number, default: 0 },
    },

    data: () => ({ localRows: [], historyRow: null }),

    computed: {
      ynKeys () { return ['contractual', 'delivered', 'approved'] },
    },

    watch: {
      resetKey: { immediate: true, handler () { this.initRows() } },
    },

    methods: {
      initRows () {
        this.localRows = (this.rows || []).map((r) => ({ ...r, id: r.id || genId(), _editing: false }))
      },
      docLabel (v) { const o = this.docTypeOptions.find((x) => x.value === v); return o ? o.label : v },
      ynLabel (v) { const o = this.ynOptions.find((x) => x.value === v); return o ? o.label : '' },
      ynClass (v) { return v === 'yes' ? 'yes' : v === 'no' ? 'no' : v === 'na' ? 'na' : '' },

      fileFor (row) { return this.files[row.id] || null },
      uploadUrl (row) { return `${this.baseUrl}/contract-files/document/${row.id}` },
      onFileUploaded () { this.emit(); this.$emit('files-changed') },
      toggleHistory (rowId) { this.historyRow = this.historyRow === rowId ? null : rowId },

      toggleEdit (i) { this.localRows[i]._editing = !this.localRows[i]._editing },
      onEdit (i, key, value) { this.localRows[i][key] = value; this.emit() },
      addRow () {
        this.localRows.push({ id: genId(), document: '', contractual: '', delivered: '', approved: '', comments: '', _editing: true })
        this.emit()
      },
      removeRow (i) {
        const file = this.fileFor(this.localRows[i])
        this.localRows.splice(i, 1)
        this.emit()
        if (file) this.$emit('remove-file', file.id)
      },
      emit () {
        const clean = this.localRows.map((r) => { const row = { ...r }; delete row._editing; return row })
        this.$emit('change', clean)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .doc-table { overflow-x: auto; }
  table { width: 100%; border-collapse: collapse; }
  th {
    background: #3d6b9a; color: #fff; font-size: 9px; text-transform: uppercase; letter-spacing: .025em;
    font-weight: 700; padding: 6px 8px; text-align: left; white-space: nowrap;
  }
  th.c { text-align: center; }
  th.act { width: 70px; }
  td { border-bottom: 1px solid #eef0f3; padding: 6px 8px; font-size: 10px; color: #1f2837; vertical-align: middle; }
  td.c { text-align: center; }
  td.empty { text-align: center; color: #9aa4b2; padding: 12px; }
  // Fila del histórico documental desplegado (bajo el registro).
  .hist-tr td { padding: 6px 10px; background: #fafbfc; }
  .doc-table:not(.mark) tbody tr:hover td { background: #f3f6fa; }

  .di-val { font-size: 10px; color: #1f2837; }
  .di-val.empty { color: #9aa4b2; }
  // Si / No / N/A en reposo: texto coloreado (sin fondo).
  .di-yn { font-size: 10px; font-weight: 600; }
  .di-yn.yes { color: #1e8449; }
  .di-yn.no { color: #c0392b; }
  .di-yn.na { color: #6b7280; }

  .di-sel, .di-in {
    width: 100%; font-size: 10px; color: #1f2837; border: 1px solid #d8dde4; border-radius: 4px;
    padding: 3px 6px; height: 24px; box-sizing: border-box; outline: none; background: #fff;
  }
  .di-sel:focus, .di-in:focus { border-color: #3a6bc8; box-shadow: 0 0 0 2px rgba(58, 107, 200, .12); }
  .di-sel.yn { width: 56px; }
  .di-in::placeholder { color: #9aa4b2; }

  // Botones de accion: cuadrado con borde, icono gris (hover azul; borrar hover rojo), como el diseno.
  .act-btns { display: inline-flex; align-items: center; justify-content: center; gap: 4px; }
  .ib {
    display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px;
    border: 1px solid #d8dde4; border-radius: 4px; background: #fff; color: #6b7280; cursor: pointer;
  }
  .ib:hover { color: #2f5f8f; border-color: #b9cde0; }
  .ib.rm { color: #9ca3af; }
  .ib.rm:hover { color: #dc2626; border-color: #f0c2c2; }

  // Modo "sin fuente" (Fuente de datos): tinte ambar en las filas, como el resto de tablas manuales.
  .doc-table.mark tbody td { background: #fff8e6; }
</style>
